import React, { useContext, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { LTSContext } from '../../../../context/LTSContext';
import { LABELS, LTS_ROUTES_PATH } from '../../../../constants/LTSConstants';
import CheckStatusButton from '../CheckStatusButton/CheckStatusButton.component';
import { isMobile } from '../../../../../../utils/commonUtils';
import useOutsideClick from '../../../../utils/useOutsideClick';
import { AutoSuggestTrainsList } from '../../../LTSTrainNumber/components/AutoSuggestTrainsList/AutoSuggestTrainsList';

const TrainSelect = (props) => {
  const { handleCheckStatus } = props;
  const history = useHistory();
  const ltsContext = useContext(LTSContext);
  const [showPopup, setShowPopup] = useState(false);
  const [query, setQuery] = useState('');

  const { trainDetail, dateSectionData } = ltsContext;
  const { trainName = '', trainNumber = '' } = trainDetail;

  const inputRef = useRef(null);
  const popupRef = useRef(null);
  useOutsideClick(popupRef, () => {
    setQuery('');
    setShowPopup(false);
  });

  const closeInputFocus = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    inputRef.current?.blur();
  };

  const handleSelectClick = (event) => {
    event.preventDefault();
    if (isMobile()) {
      history.push(LTS_ROUTES_PATH.trainNumberPage);
    } else {
      setQuery('');
      if (showPopup) {
        closeInputFocus();
      }
      setShowPopup(!showPopup);
    }
  };

  const onChange = (event) => {
    setQuery(event.target.value);
  };

  const handleDesktopTrainSelect = () => {
    setShowPopup(false);
  };

  const onCheckStatusClick = (event) => {
    event.stopPropagation();
    handleCheckStatus();
  };

  return (
    <>
      <div
        className="LTSLanding-TrainSelect-wrapper LTSPageCommon-click-transition"
        onClick={handleSelectClick}
        ref={popupRef}
      >
        <div className="LTSLanding-TrainSelect-select">
          <span className="LTSLanding-TrainSelect-label appendBottom10 mobileShow">{LABELS.TRAIN_PICKER_TITLE}</span>
          <input
            className={`desktopShow ${
              trainNumber ? 'LTSLanding-TrainSelect-text-input-trainDetail' : 'LTSLanding-TrainSelect-text-input'
            }`}
            ref={inputRef}
            value={query}
            placeholder={trainNumber ? `${trainNumber} - ${trainName}` : LABELS.TRAIN_SEARCH_INPUT_PLACEHOLDER}
            onChange={onChange}
          />
          {trainNumber ? (
            <span className="LTSLanding-TrainSelect-train-number mobileShow LTSPageCommon-text-overflow-ellipsis">
              {trainNumber}
              {trainName && <span className="LTSLanding-TrainSelect-train-name">{trainName}</span>}
            </span>
          ) : (
            <span className="LTSLanding-TrainSelect-select-text mobileShow">
              {LABELS.TRAIN_SEARCH_INPUT_PLACEHOLDER}
            </span>
          )}
          {showPopup && (
            <div className="LTSLanding-TrainSelect-popup desktopShow">
              <AutoSuggestTrainsList searchQuery={query} handleOnTrainSelected={handleDesktopTrainSelect} />
            </div>
          )}
        </div>
        <CheckStatusButton
          isInvalid={!trainDetail?.trainNumber || !dateSectionData?.clearance}
          onClick={onCheckStatusClick}
        />
      </div>
    </>
  );
};

TrainSelect.propTypes = {
  handleCheckStatus: PropTypes.func
};

export default TrainSelect;
